/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  Shop,
  ShopInput,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Shop Detail
 */
export const shop = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Shop>(
      {url: `/shops/${id}`, method: 'GET', signal
    },
      );
    }




export const getShopQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'shops',id
    ] as const;
    }


export const getShopQueryOptions = <TData = Awaited<ReturnType<typeof shop>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shop>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShopQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shop>>> = ({ signal }) => shop(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shop>>, TError, TData>
}

export type ShopQueryResult = NonNullable<Awaited<ReturnType<typeof shop>>>
export type ShopQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Shop Detail
 */

export function useShop<TData = Awaited<ReturnType<typeof shop>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shop>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Shop
 */
export const updateShop = (
    id: MaybeRefOrGetter<string>,
    shopInput: MaybeRefOrGetter<ShopInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
shopInput = toValue(shopInput);

      return axiosClient<Shop>(
      {url: `/shops/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: shopInput, signal
    },
      );
    }




export const getUpdateShopMutationKey = () => ['updateShop'] as const;

export const getUpdateShopMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShop>>, TError,UpdateShopMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateShop>>, TError,UpdateShopMutationVariables, TContext> => {

const mutationKey = getUpdateShopMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateShop>>, UpdateShopMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateShop(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateShopMutationResult = NonNullable<Awaited<ReturnType<typeof updateShop>>>
    export type UpdateShopMutationBody = ShopInput
    export type UpdateShopMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateShopMutationVariables = {id: string;data: ShopInput}

    /**
 * @summary Update Shop
 */
export const useUpdateShop = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShop>>, TError,UpdateShopMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateShop>>,
        TError,
        UpdateShopMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateShopMutationOptions(options), queryClient);
    }
